// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EmQM","right":"styles_right__1yLyf"};